import * as React from 'react';
import { SVGProps } from 'react';

const SvgVerifyId = (props: SVGProps<SVGSVGElement>) => (
  <svg width={150} height={150} viewBox="0 0 150 150" fill="none" role="img" {...props}>
    <circle cx={75} cy={90} r={60} fill="#EAEAF0" />
    <rect
      x={50}
      y={74}
      width={92}
      height={60}
      rx={4}
      fill="#E9F9FB"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      d="M51.438 127.906h89.124v2.188a2.5 2.5 0 0 1-2.5 2.5H53.937a2.5 2.5 0 0 1-2.5-2.5v-2.188Z"
      fill="#6AD5E5"
    />
    <rect x={108.458} y={89.938} width={24.917} height={4.688} rx={2.344} fill="currentColor" />
    <rect x={100.792} y={102.125} width={32.583} height={4.688} rx={2.344} fill="currentColor" />
    <rect x={93.125} y={114.312} width={40.25} height={4.688} rx={2.344} fill="currentColor" />
    <path
      d="M67.393 118.388a2.889 2.889 0 0 1-1.994-.808l-4.639-4.551a2.76 2.76 0 0 1 0-3.912c1.084-1.064 2.905-1.064 3.989 0l2.644 2.594 10.882-10.675c1.084-1.063 2.905-1.063 3.989 0s1.084 2.849 0 3.913L69.388 117.58a2.89 2.89 0 0 1-1.995.808Z"
      fill="currentColor"
    />
    <circle cx={75.891} cy={47.44} r={35} fill="#fff" />
    <path
      d="m59.39 82 1.71-13.574s.267-3.388 5.362-4.517c0 0 8.794 3.119 13.941-.591 0 0 5.095-.753 7.454 4.624l2.038 7.69.496 5.868-5.5 2.474L76.39 85l-10.5-1.026L59.39 82Z"
      fill="#FF4496"
    />
    <path
      d="M90.825 82.838c-.858 0-1.555-.645-1.662-1.506 0-.107-.555-7.475-1.36-13.82-.643-4.894-7.828-5.27-7.882-5.27-.912-.054-1.662-.806-1.609-1.774.054-.915.805-1.667 1.77-1.614.107 0 2.467.108 4.987 1.076 3.592 1.398 5.684 3.871 6.113 7.152.858 6.345 1.36 13.766 1.36 13.874.106.914-.537 1.774-1.449 1.882h-.268Z"
      fill="currentColor"
    />
    <path
      d="m59.813 44.658 3.646-4.14 1.984 3.388 10.349-1.29 8.901-4.68 4.397-7.42-.429.215s-.536 2.259-17.052.807c0 0-8.204-.645-11.796 13.12Z"
      fill="#6AD5E5"
    />
    <path
      d="M73.7 63.694c-8.579 0-15.55-6.99-15.55-15.594 0-.645.054-1.29.108-1.936l3.378.43a14.215 14.215 0 0 0-.108 1.506c0 6.721 5.47 12.206 12.173 12.206S85.873 54.821 85.873 48.1v-.377l3.378-.107v.43c0 8.657-6.97 15.648-15.55 15.648Z"
      fill="currentColor"
    />
    <path
      d="M59.92 48.53h-.054c-.75 0-1.34-.538-1.555-1.237-.107-.43-2.788-10.055 4.612-17.476.429-.484 4.826-4.786 12.011-2.904 6.542 1.775 10.993 1.829 14.264.323a1.57 1.57 0 0 1 1.608.108c.483.322.805.86.805 1.398 0 .161-.215 17.153-27.08 17.314a1.71 1.71 0 0 1-1.287-.591 1.436 1.436 0 0 1-.375-.753c-.536.807-1.019 1.72-1.34 2.689-.322.699-.912 1.129-1.61 1.129Zm6.864-12.206c.428 0 .911.161 1.233.537.59.592.643 1.56.107 2.205-.697.914-1.233 2.366-1.555 3.549 15.604-.645 19.948-7.528 21.18-11.346-3.592.807-7.935.43-13.673-1.075-5.47-1.452-8.687 1.882-8.74 1.935l-.054.054c-2.95 2.958-3.914 6.345-4.129 9.088 2.145-2.797 4.504-4.517 4.665-4.625.268-.215.59-.322.966-.322Z"
      fill="currentColor"
    />
    <path
      d="M87.535 49.39c-.321 0-.643-.107-.911-.269a1.777 1.777 0 0 1-.483-2.366c3.218-4.839.697-11.83.697-11.937a1.656 1.656 0 0 1 1.02-2.15 1.649 1.649 0 0 1 2.144 1.02c.107.377 3.11 8.712-1.072 14.95a1.684 1.684 0 0 1-1.395.752ZM73.54 57.564c-2.735 0-5.04-1.13-6.22-2.044-.751-.591-.858-1.667-.268-2.366.59-.752 1.662-.86 2.359-.268.16.16 3.914 2.957 8.311-.054.751-.538 1.824-.323 2.36.43.536.753.322 1.828-.43 2.366-2.09 1.398-4.235 1.936-6.112 1.936ZM56.576 79.838h-.214c-.912-.108-1.609-.968-1.448-1.882 0-.108.555-4.53 1.36-10.874.428-3.28 2.573-5.754 6.112-7.152 2.52-.968 4.88-1.076 4.987-1.076.912-.053 1.716.7 1.77 1.614.053.914-.697 1.72-1.609 1.774-.107 0-7.239.377-7.883 5.27-.804 6.345-1.359 10.713-1.359 10.82a1.735 1.735 0 0 1-1.716 1.506ZM81.262 85.554c-.805 0-1.502-.592-1.663-1.398l-1.34-8.31c-.161-.914.429-1.828 1.34-1.99.912-.16 1.823.431 1.984 1.345l1.34 8.31c.162.913-.428 1.828-1.34 1.989-.107.054-.214.054-.321.054ZM65.89 84.5c-.106 0-.214 0-.321-.054-.912-.161-1.502-1.075-1.34-1.99l1-7.255c.16-.914 1.072-1.505 1.983-1.344.912.161 1.502 1.075 1.341 1.99l-1 7.255c-.16.806-.858 1.398-1.662 1.398Z"
      fill="currentColor"
    />
    <path
      d="M75.574 86.65c-9.862 0-19.724-3.764-27.234-11.295-15.019-15.061-15.019-39.558 0-54.62 15.02-15.06 39.448-15.06 54.467 0 15.019 15.062 15.019 39.559 0 54.62-7.464 7.53-17.371 11.296-27.233 11.296Zm0-72.674c-8.686 0-17.417 3.312-24.022 9.98-13.255 13.293-13.255 34.886 0 48.178 13.255 13.292 34.789 13.292 48.043 0 6.424-6.442 9.953-14.97 9.953-24.089 0-9.118-3.529-17.647-9.953-24.088a33.828 33.828 0 0 0-24.021-9.98Z"
      fill="currentColor"
    />
    <path
      d="M17.171 108.925a2.295 2.295 0 0 1-1.628-.68c-.905-.908-.905-2.359 0-3.221l32.797-32.89c.905-.907 2.353-.907 3.212 0 .905.907.905 2.36 0 3.221l-32.797 32.89c-.408.453-.996.68-1.584.68Z"
      fill="currentColor"
    />
    <path
      d="M37.935 85.834c2.489 2.495 2.489 6.533 0 8.983l-20.221 20.278c-2.488 2.495-6.514 2.495-8.957 0-2.488-2.495-2.488-6.533 0-8.983l20.176-20.278a6.35 6.35 0 0 1 9.002 0Z"
      fill="#6AD5E5"
    />
    <path d="M27.307 87.487 23.404 91.4l8.957 8.982 3.903-3.913-8.957-8.982Z" fill="currentColor" />
  </svg>
);

export default SvgVerifyId;
